export function Utils() {
  var createObject = Object.create;
  var defineProperty = Object.defineProperty;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getPrototypeOf = Object.getPrototypeOf;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var handleCommonJSModule = (cb, mod) =>
    function __require() {
      return mod || (0, cb[getOwnPropertyNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
  var copyProperties = (to, from, except, desc) => {
    if ((from && typeof from === 'object') || typeof from === 'function') {
      for (let key of getOwnPropertyNames(from))
        if (!hasOwnProperty.call(to, key) && key !== except)
          defineProperty(to, key, {
            get: () => from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable,
          });
    }
    return to;
  };
  var convertToESM = (mod, isNodeMode, target) => (
    (target = mod != null ? createObject(getPrototypeOf(mod)) : {}),
    copyProperties(
      isNodeMode || !mod || !mod.__esModule
        ? defineProperty(target, 'default', { value: mod, enumerable: true })
        : target,
      mod
    )
  );
  var accessCheck = (obj, member, msg) => {
    if (!member.has(obj)) throw TypeError('Cannot ' + msg);
  };
  var getPrivate = (obj, member, getter) => {
    accessCheck(obj, member, 'read from private field');
    return getter ? getter.call(obj) : member.get(obj);
  };
  var addPrivate = (obj, member, value) => {
    if (member.has(obj)) throw TypeError('Cannot add the same private member more than once');
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  };
  var setPrivate = (obj, member, value, setter) => {
    accessCheck(obj, member, 'write to private field');
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
  };
  var privateMethod = (obj, member, method) => {
    accessCheck(obj, member, 'access private method');
    return method;
  };
  return {
    handleCommonJSModule,
    addPrivate,
    privateMethod,
    getPrivate,
    setPrivate,
    convertToESM,
  };
}
